<template>
  <div class="tag-info">
    <div class="tag-info__inner">
      <h5 class="tag-info__title">Edit Tag</h5>
      <div class="tag-info__col">
        <div v-if="value.type !== 'slide'" class="tag-info__block">
          <label>Type</label>
          <select
            v-model="value.type"
            class="form-control"
            @change="onTypeChange"
          >
            <option value="basic">Basic</option>
            <option value="basicIcon">Basic Icon</option>
            <option value="box">Box</option>
            <option value="rich">Rich</option>
            <option value="reference">Reference</option>
            <option value="reveal">Reveal</option>
            <option value="action">Action</option>
          </select>
        </div>
        <div
          v-if="
            [
              'basic',
              'basicIcon',
              'box',
              'rich',
              'reference',
              'reveal',
              'action',
              'slide'
            ].indexOf(value.type) !== -1
          "
          class="tag-info__block"
        >
          <label>
            Label
            <localised-field-indicator />
          </label>
          <input
            v-model="value.label[activeLanguage.code]"
            class="form-control"
            type="text"
            placeholder="label"
          />
        </div>
        <div v-if="value.pos" class="tag-info__block tag-info__block--inline">
          <label>X</label>
          <input
            type="number"
            v-model.number="value.pos.x"
            class="form-control"
          />
        </div>
        <div v-if="value.pos" class="tag-info__block tag-info__block--inline">
          <label>Y</label>
          <input
            type="number"
            v-model.number="value.pos.y"
            class="form-control"
          />
        </div>
        <div
          v-if="value.pos"
          class="tag-info__block tag-info__block--inline tag-info__block--inactive"
        >
          <label>W</label>
          <input type="text" v-model.number="width" readonly />
        </div>
        <div
          v-if="value.pos"
          class="tag-info__block tag-info__block--inline tag-info__block--inactive"
        >
          <label>H</label>
          <input type="text" v-model.number="height" readonly />
        </div>
        <div
          v-if="['slide'].indexOf(value.type) !== -1"
          class="tag-info__block"
        >
          <label>Should slide expand</label>
          <toggle-button
            v-model="value.shouldSlideExpand"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
          />
        </div>
      </div>

      <div v-if="['basic'].indexOf(value.type) !== -1" class="tag-info__col">
        <div class="tag-info__block tag-info__block--inline">
          <label style="flex-shrink: 0; margin-right: 10px;">Font Size</label>
          <input
            class="form-control"
            type="number"
            step="0.01"
            v-model.number="value.fontSize"
          />
        </div>

        <div
          v-if="value.padding"
          class="tag-info__block tag-info__block--inline"
        >
          <label style="flex-shrink: 0; margin-right: 10px;">Padding</label>
          <div class="group-block__inputs">
            <div class="group-block__input-wrapper">
              <label>Top</label>
              <input
                class="form-control"
                type="number"
                step="0.01"
                v-model="value.padding[0]"
              />
            </div>
            <div class="group-block__input-wrapper">
              <label>Bottom</label>
              <input
                class="form-control"
                type="number"
                step="0.01"
                v-model="value.padding[2]"
              />
            </div>
            <div class="group-block__input-wrapper">
              <label>Left</label>
              <input
                class="form-control"
                type="number"
                step="0.01"
                v-model="value.padding[3]"
              />
            </div>
            <div class="group-block__input-wrapper">
              <label>Right</label>
              <input
                class="form-control"
                type="number"
                step="0.01"
                v-model="value.padding[1]"
              />
            </div>
          </div>
        </div>

        <div class="tag-info__block tag-info__block--inline">
          <label style="flex-shrink: 0; margin-right: 10px;">Rotation</label>
          <input
            class="form-control"
            type="number"
            v-model.number="value.rotation"
          />
        </div>

        <div class="tag-info__block tag-info__block--inline">
          <label style="flex-shrink: 0; margin-right: 10px;">Box Shadow</label>
          <input
            class="form-control"
            type="checkbox"
            v-model.number="value.boxShadow"
          />
        </div>
      </div>

      <div class="tag-info__col element-grow">
        <div v-if="['box'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>
            distance
            <localised-field-indicator />
          </label>
          <input
            v-model="value.distance[activeLanguage.code]"
            class="form-control"
            type="text"
            placeholder="distance"
          />
        </div>
        <div v-if="['box'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>Arrow degrees</label>
          <input
            v-model.number="value.arrowDeg"
            class="form-control"
            type="number"
            placeholder="arrow degrees"
          />
        </div>
        <div
          v-if="['box', 'action', 'rich'].indexOf(value.type) !== -1"
          class="tag-info__block"
        >
          <label
            >Icon Code
            <info-box class="ml-1">
              For a full list of codes head to
              <a href="https://fontawesome.com/cheatsheet" target="_blank"
                >https://fontawesome.com/cheatsheet</a
              >
            </info-box>
          </label>
          <div class="icon-selector">
            <div class="icon-selector__input icon-selector__input--preview">
              <input
                v-model="value.icon"
                class="form-control"
                type="text"
                placeholder="Icon code"
              />
              <div class="icon-selector__preview">
                <fa v-if="value.icon" :icon="['fas', value.icon]" />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="['basic', 'action', 'rich'].indexOf(value.type) !== -1"
          class="tag-info__block"
          :key="value.action.method"
        >
          <label>Assign Action</label>
          <select
            v-model="value.action.method"
            class="form-control"
            @change="methodChanged"
          >
            <option value="">Unassigned</option>
            <option value="TRIGGER_CHANGE_BACKGROUND">Change Background</option>
            <option value="TRIGGER_SHOW_ASSET">Show Asset</option>
            <option value="TRIGGER_NAV_ROUTER">Navigate to page</option>
            <option value="TRIGGER_CUSTOM_NAV_ROUTER">
              Navigate to custom page
            </option>
          </select>
          <input-asset
            v-if="value.action.method === 'TRIGGER_CHANGE_BACKGROUND'"
            class="mt-2"
            v-model="value.action.payload[0]"
          />
          <input-asset
            v-if="value.action.method === 'TRIGGER_SHOW_ASSET'"
            class="mt-2"
            :multiple="true"
            v-model="value.action.payload"
          />
          <div
            v-if="value.action.method === 'TRIGGER_SHOW_ASSET'"
            class="mt-2"
            style="width: 100%"
          >
            <label
              >Virtual Tour Url
              <info-box class="ml-1">
                The last asset will open virtual tour url when clicked
              </info-box>
            </label>
            <input
              v-model="value.virtualTourUrl"
              class="form-control"
              type="text"
              placeholder=""
            />
          </div>
          <select
            v-if="value.action.method === 'TRIGGER_NAV_ROUTER'"
            v-model="value.action.payload[0]"
            class="form-control mt-2"
          >
            <option value="">Select a page</option>
            <option v-for="page in pages" :key="page._id" :value="page._id">
              {{ page.heading.en || page.name }}
            </option>
          </select>
          <input
            v-if="value.action.method === 'TRIGGER_CUSTOM_NAV_ROUTER'"
            class="form-control mt-2"
            type="text"
            v-model="value.action.payload[0]"
          />
        </div>
        <div
          v-if="['reference'].indexOf(value.type) !== -1"
          class="tag-info__block"
        >
          <label
            >Order override
            <info-box class="ml-1">
              Set a custom order for a tag from low to high. Numbers can be
              negative.
            </info-box>
          </label>
          <input
            v-model="value.overrideOrder"
            class="form-control"
            type="text"
            placeholder="0"
          />
        </div>
        <div
          v-if="['reference'].indexOf(value.type) !== -1"
          class="tag-info__block"
        >
          <label>Is Visible</label>
          <toggle-button
            v-model="value.isVisible"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
          />
        </div>
        <div
          v-if="['rich', 'reference', 'reveal'].indexOf(value.type) !== -1"
          class="tag-info__block element-grow"
        >
          <label>
            description
            <localised-field-indicator />
          </label>
          <textarea
            v-model="value.description[activeLanguage.code]"
            class="form-control element-grow"
            rows="3"
            placeholder="description"
          ></textarea>
        </div>
        <div
          v-if="['rich'].indexOf(value.type) !== -1"
          class="tag-info__block element-grow"
        >
          <label>
            More Information
            <localised-field-indicator />
          </label>
          <textarea
            v-model="value.moreInformation[activeLanguage.code]"
            class="form-control element-grow"
            rows="3"
            placeholder="more information"
          ></textarea>
        </div>
        <div
          v-if="['rich'].indexOf(value.type) !== -1"
          class="tag-info__block element-grow"
        >
          <label>QR URL</label>
          <input
            v-model="value.qrUrl"
            class="form-control"
            type="text"
            placeholder="https://"
          />
        </div>
        <!-- background colour -->
        <div
          v-if="
            ['basic', 'basicIcon', 'box', 'action', 'rich'].indexOf(
              value.type
            ) !== -1
          "
          class="tag-info__block"
        >
          <div class="inline-label">
            <label>Background Colour</label>

            <div class="colour-controls">
              <div
                class="btn-colour"
                :style="{ backgroundColor: value.backgroundColour }"
                @click="toggleColourWidget('backgroundColour')"
              ></div>

              <!-- eyedropper button -->
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm colour-eye-button"
                @click="pickColour('backgroundColour')"
              >
                <fa :icon="['fas', 'eye-dropper']" />
              </button>
            </div>
          </div>

          <verte
            v-if="activeColourWidget === 'backgroundColour'"
            class="colour-picker"
            display="widget"
            picker="square"
            model="rgb"
            v-model="value.backgroundColour"
          ></verte>
        </div>

        <!-- text colour -->
        <div
          v-if="
            ['basic', 'basicIcon', 'box', 'rich'].indexOf(value.type) !== -1
          "
          class="tag-info__block"
        >
          <div class="inline-label">
            <label>Text Colour</label>
            <div class="colour-controls">
              <div
                class="btn-colour"
                :style="{ backgroundColor: value.textColour }"
                @click="toggleColourWidget('textColour')"
              ></div>

              <!-- eyedropper button -->
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm colour-eye-button"
                @click="pickColour('textColour')"
              >
                <fa :icon="['fas', 'eye-dropper']" />
              </button>
            </div>
          </div>

          <verte
            v-if="activeColourWidget === 'textColour'"
            class="colour-picker"
            display="widget"
            picker="square"
            model="rgb"
            v-model="value.textColour"
          ></verte>
        </div>

        <div
          v-if="
            ['basic', 'reference', 'rich', 'action'].indexOf(value.type) !== -1
          "
          class="tag-info__block"
        >
          <label>Tail Position</label>
          <select v-model="value.tailPosition" class="form-control">
            <option value="none">No Tail</option>
            <option value="bottom-left">Bottom Left</option>
            <option value="bottom-center">Bottom Center</option>
            <option value="bottom-right">Bottom Right</option>
            <option value="top-left">Top Left</option>
            <option value="top-center">Top Center</option>
            <option value="top-right">Top Right</option>
            <option value="left-center">Left Center</option>
            <option value="right-center">Right Center</option>
          </select>
        </div>
        <div
          v-if="
            ['basic', 'reference', 'rich', 'action'].indexOf(value.type) !==
              -1 && value.tailPosition !== 'none'
          "
          class="tag-info__block"
        >
          <label>Tail Height</label>
          <input
            v-model="value.tailHeight"
            class="form-control"
            type="text"
            placeholder="4"
          />
        </div>
        <div v-if="['rich'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>Flip</label>
          <toggle-button
            v-model="value.flip"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
          />
        </div>
        <div v-if="['rich'].indexOf(value.type) !== -1" class="tag-info__block">
          <label>Overlay Content</label>
          <toggle-button
            v-model="value.overlayContent"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
          />
        </div>
        <div
          v-if="['rich'].indexOf(value.type) !== -1 && value.overlayContent"
          class="tag-info__block"
        >
          <label>Overlay Opacity</label>
          <input
            v-model.number="value.overlayOpacity"
            step=".1"
            min="0"
            max="1"
            class="form-control"
            type="number"
            placeholder=".5"
          />
        </div>
        <div
          v-if="['basic'].indexOf(value.type) !== -1"
          class="tag-info__block"
        >
          <label>Highlight Tag</label>
          <toggle-button
            v-model="value.isHighlighted"
            color="#28a745"
            :sync="true"
            :labels="false"
            :width="40"
            :height="20"
            style="font-weight: 400"
          />
        </div>
        <div v-if="value.type === 'slide'" class="tag-info__col">
          <div class="tag-info__block">
            <label>Background Image Override</label>
            <input-asset
              v-model="value.backgroundImageOverride"
              defaultCategory="tagImage"
            ></input-asset>
          </div>
        </div>
      </div>

      <div
        v-if="['rich', 'reference', 'reveal'].indexOf(value.type) !== -1"
        class="tag-info__col"
      >
        <div class="tag-info__block">
          <label>Asset</label>
          <input-asset
            v-model="value.assetId"
            defaultCategory="tagImage"
            :returnid="true"
          ></input-asset>
        </div>
      </div>

      <div v-if="value.type === 'slide'" class="tag-info__col">
        <div class="tag-info__block">
          <label>Slide Media</label>
          <input-asset
            :returnid="true"
            v-model="value.assetId"
            defaultCategory="tagImage"
          ></input-asset>
        </div>
      </div>

      <div class="tag-info__col tag-info__col--last buttons-row">
        <!-- Duplicate button (tags only, not slides) -->
        <button
          v-if="value.type !== 'slide'"
          class="btn btn-duplicate"
          @click="$emit('duplicate', value)"
        >
          Duplicate
        </button>

        <!-- Remove button -->
        <button class="btn btn-remove" @click="$emit('remove', value._id)">
          Remove
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_PAGES } from "@/store/actions.type";
import InfoBox from "@/components/InfoBox";
import InputAsset from "@/components/InputAsset";
import Verte from "verte";
import "verte/dist/verte.css";

export default {
  components: { InfoBox, InputAsset, Verte },

  props: ["value", "isSlideSelected"],

  data() {
    return {
      height: 0,
      width: 0,
      activeColourWidget: null,
      isTagInfoHidden: true
    };
  },

  computed: {
    ...mapGetters(["pages", "activeLanguage"]),

    actionMetaValue() {
      this.ensureAction();
      return this.value.action.meta.objectFit === "cover";
    }
  },

  watch: {
    value: {
      deep: true,
      immediate: false,
      handler(newValue) {
        this.ensureAction();

        if (newValue.type === "slide") {
          this.$emit("updateSlide", newValue);
        }

        if (!newValue._id) {
          this.isTagInfoHidden = true;
        }
      }
    }
  },

  created() {
    this.ensureAction();
    this.$store.dispatch(FETCH_PAGES);
  },

  methods: {
    ensureAction() {
      if (!this.value.action) {
        this.$set(this.value, "action", {
          method: "",
          payload: [],
          meta: {
            objectFit: "cover"
          }
        });
      }

      if (!this.value.action.meta) {
        this.$set(this.value.action, "meta", {
          objectFit: "cover"
        });
      }
    },

    methodChanged(e) {
      this.ensureAction();

      if (e.target.value === "TRIGGER_CHANGE_BACKGROUND") {
        this.value.action.payload = [""];
      }

      if (e.target.value === "TRIGGER_SHOW_ASSET") {
        this.value.action.payload = [];
      }
    },

    toggleColourWidget(key) {
      if (key === this.activeColourWidget) {
        this.activeColourWidget = null;
      } else {
        this.activeColourWidget = key;
      }
    },

    onTypeChange(e) {
      const newType = e.target.value;

      const defaultBackgroundColours = {
        basic: "#ffffff",
        basicIcon: "#2e2e2f",
        box: "#000000",
        rich: "#ffffff",
        reveal: "#000000",
        action: "#000000"
      };

      const defaultTextColours = {
        basic: "#000000", // black on white
        basicIcon: "#ffffff", // white on dark
        box: "#ffffff", // white on black
        rich: "#000000", // black on white
        reveal: "#ffffff", // white on black
        action: "#ffffff" // white on black
      };

      if (
        Object.prototype.hasOwnProperty.call(defaultBackgroundColours, newType)
      ) {
        this.value.backgroundColour = defaultBackgroundColours[newType];
      }

      if (Object.prototype.hasOwnProperty.call(defaultTextColours, newType)) {
        this.value.textColour = defaultTextColours[newType];
      }
    },

    async pickColour(key) {
      if (typeof window === "undefined" || !("EyeDropper" in window)) {
        this.$notify &&
          this.$notify({
            message: "Eyedropper not supported in this browser.",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "warning"
          });
        return;
      }

      try {
        const eyeDropper = new window.EyeDropper();
        const result = await eyeDropper.open(); // opens native eyedropper

        this.$set(this.value, key, result.sRGBHex);
        this.activeColourWidget = null;
      } catch (err) {
        if (err && err.name === "AbortError") {
          return;
        }
        console.error("Eyedropper error", err);
        this.$notify &&
          this.$notify({
            message: "Error using eyedropper.",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/_mixins.scss";

.tag-info {
  background: rgba(255, 255, 255, 0.95); // same as TagInfoBox
  padding: 15px; // same inner spacing
  pointer-events: all;
  width: 100%; // fill the marker-details container
  height: 100%;
  transition: all 300ms ease-in-out;
  z-index: 100;

  &__title {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 10px;
  }

  &--hidden {
    transform: translateX(100%);
  }

  &__inner {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    width: 100%;
  }

  &__toggle {
    position: absolute;
    right: 100%;
    top: 0;
  }

  &__col {
    display: flex;
    flex-direction: column;
    margin: 0 0 5px 0;
    width: 100%;

    &--last {
      margin: auto 0 0 auto;
      max-width: 100%;
    }
  }

  &__block {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    label {
      font-size: 0.85em;
      margin: 0;
      text-transform: capitalize;
    }

    &--inline {
      align-items: center;
      flex-direction: row;
      justify-content: space-between;

      input {
        width: calc(100% - 20px);
      }
    }

    &--inactive {
      input {
        border: none;
        cursor: default;
      }
    }

    .icon-selector {
      display: flex;
      // margin: 0 -6px;
      position: relative;
      width: 100%;

      &__input {
        // padding: 0 6px;
        width: 100%;

        &--preview input {
          padding-right: 30px;
        }
      }

      &__preview {
        align-items: center;
        background: rgba(0, 0, 0, 0.15);
        border-radius: 0 3px 3px 0;
        display: flex;
        height: 100%;
        justify-content: center;
        overflow: hidden;
        position: absolute;
        right: 0;
        top: 0;
        width: 30px;
      }
    }
  }
}

.element-grow {
  flex-grow: 1;
}

.input-asset {
  width: 100%;
}

.inline-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;

  label {
    margin: 0;
    font-size: 0.85em;
    flex: 1;
  }
}

.colour-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-colour {
  border: 1px solid #111;
  border-radius: 3px;
  width: 44px;
  height: 22px;
}

.colour-eye-button {
  width: 32px;
  height: 22px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.colour-picker {
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
}

.group-block__inputs {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  input {
    width: 100%;
  }
}

.buttons-row {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  width: 100%;
}

.btn-duplicate,
.btn-remove {
  height: 36px;
  min-width: 100px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
}

/* Duplicate button */
.btn-duplicate {
  background: #6f42c1;
  color: #fff;
  border: none;

  &:hover {
    background: #59359a;
    color: #fff;
  }
}

/* Remove button */
.btn-remove {
  background: #d9534f;
  color: white;
  border: none;

  &:hover {
    background: #c9302c;
    color: #fff;
  }
}
</style>
